export const ChecklistShieldIcon = () => (
  <svg width={16} height={17} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask-cyber-checklist" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x={0} y={0} width={16} height={17}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2L3 4V7.8C3 11.52 5.5 14.87 8 16C10.5 14.87 13 11.52 13 7.8V4L8 2ZM6.5 6H9.5C9.776 6 10 6.224 10 6.5C10 6.776 9.776 7 9.5 7H6.5C6.224 7 6 6.776 6 6.5C6 6.224 6.224 6 6.5 6ZM6.5 8.5H9.5C9.776 8.5 10 8.724 10 9C10 9.276 9.776 9.5 9.5 9.5H6.5C6.224 9.5 6 9.276 6 9C6 8.724 6.224 8.5 6.5 8.5ZM5 6.5L5.5 7L6 6.5L6.5 6L6 5.5L5 6.5ZM5 9L5.5 9.5L6 9L6.5 8.5L6 8L5 9Z"
        fill="#A0AEC0"
      />
    </mask>
    <g mask="url(#mask-cyber-checklist)">
      <rect y="0.5" width={16} height={16} fill="#A0AEC0" />
    </g>
  </svg>
);
